const clickOffer = () => {
  const currentPlan = document.querySelectorAll(".offer");
  const currentType = document.querySelectorAll('.plan__tab');

  currentPlan.forEach((offer) => {
    offer.addEventListener("click", (e) => {
      e.preventDefault();
      toggleClassOffer()
      const currentFlavor = e.currentTarget.getAttribute('data-flavor')
      const flavorArrow = document.querySelector(`.arrow--${currentFlavor}`)
      const flavorImage = document.querySelectorAll(`.flavor__img--${currentFlavor}`)
      const flavorText = document.querySelectorAll(`.flavor__text--${currentFlavor}`)
      const flavorValue = document.getElementById('form-product-name')
      const flavorValueTanpin = document.getElementById('form-product-name-tanpin')
      flavorArrow.classList.add("tw-block");
      flavorArrow.classList.remove("tw-hidden");


      flavorValue.options[currentFlavor === 'choco' ? 1 : 0].selected = true
      flavorValueTanpin.options[currentFlavor === 'choco' ? 0 : 3].selected = true

      flavorImage.forEach((image) => {
        image.classList.add("tw-block");
        image.classList.remove("tw-hidden");
      })

      flavorText.forEach((text) => {
        text.classList.add("tw-block");
        text.classList.remove("tw-hidden");
      })

      e.currentTarget.classList.add('tw-border-[#FFFF05]', 'tw-border-[3px]', 'md:tw-border-[6px]')
      e.currentTarget.classList.remove('tw-brightness-50')
    })
  })

  currentType.forEach((type) => {
    type.addEventListener("click", (e) => {
      e.preventDefault();

      currentType.forEach((t) => {
        t.classList.remove('tw-bg-[#FFFF05]')
        t.classList.add('tw-bg-[#909090]', 'tw-text-white')
        e.currentTarget.classList.add('tw-bg-[#FFFF05]', 'tw-text-[#202020]')
        e.currentTarget.classList.remove('tw-text-white', 'tw-text-[#202020]')
      })

      const planType = e.currentTarget.getAttribute('data-type')
      const planContents = document.querySelectorAll(`.plan__content`)

      planContents.forEach((content) => {
        content.classList.add('tw-hidden');
        const planTypeContent = content.getAttribute('data-type')
        if (planType === planTypeContent) {
          content.classList.remove('tw-hidden');
        }
      })

    })
  })
}

const toggleClassOffer = () => {
  const currentPlan = document.querySelectorAll(".offer");
  const arrows = document.querySelectorAll('.arrow');
  const flavorImages = document.querySelectorAll('.flavor__img');
  const flavorText = document.querySelectorAll('.flavor__text');

  currentPlan.forEach((offer) => {
    offer.classList.remove('tw-border-[3px]', 'md:tw-border-[6px]', 'tw-border-[#FFFF05]')
    offer.classList.add('tw-brightness-50')
  })

  arrows.forEach((arrow) => {
    arrow.classList.add('tw-hidden')
  })

  flavorImages.forEach((flavor) => {
    flavor.classList.add('tw-hidden')
  })

  flavorText.forEach((flavor) => {
    flavor.classList.add('tw-hidden')
  })
}

const clickBuyButton = () => {
  document.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', event => {
      const href = link.getAttribute('href');  // href属性を取得

      // hrefが#で始まるIDを持っているかチェック
      if (href.startsWith('#') && href.length > 1) {
        event.preventDefault();  // デフォルトのアンカー動作をキャンセル
        const targetElement = document.getElementById(href.slice(1));  // IDから先頭の#を削除して要素を取得

        if (targetElement) {
          // 要素が存在する場合、スムーススクロールを実行
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // hrefにIDがない場合、ページトップにスクロール
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        window.href = href
      }
    });
  });
};

clickBuyButton();
clickOffer()